// Date range filter for the Pending and Unmatched tabs.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function PendingDateRange({ afterDate, afterStatus, busy, isReviewable, pendFrom, pendTo, refresh, setPendFrom, setPendTo, setSelected }) {
  return (
    <>
      {isReviewable && (
        <div className="card" style={{ padding: '0.5rem 1rem', marginBottom: '0.5rem', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.75rem' }}>
          <span className="small" style={{ color: '#334155', fontWeight: 600 }}>Date range:</span>
          <label className="small">From <input type="date" value={pendFrom}
                 onChange={e => { setPendFrom(e.target.value); setSelected(new Set()); }}
                 style={{ marginLeft: 4 }} /></label>
          <label className="small">To <input type="date" value={pendTo}
                 onChange={e => { setPendTo(e.target.value); setSelected(new Set()); }}
                 style={{ marginLeft: 4 }} /></label>
          <button className="refresh-btn" disabled={busy || (!pendFrom && !pendTo)}
                  onClick={() => { setPendFrom(''); setPendTo(''); setSelected(new Set()); }}
                  style={{ background: '#666' }}>Clear date filter</button>
          {(pendFrom || pendTo) && (
            <span className="small" style={{ color: '#64748b', marginLeft: 'auto' }}>
              {afterDate.length.toLocaleString()} of {afterStatus.length.toLocaleString()} rows in range
            </span>
          )}
        </div>
      )}
    </>
  );
}
